export default "__VITE_ASSET__a0478f1b__"